export class BaseUser {

    public static stringifyExclude: string[] = [
        "stringifyExclude",
        "registry"
    ];

    private _email: string = "";
    private _user_roles: string[] = [""];
    
    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get user_roles(): string[] {
        return this._user_roles;
    }

    public set user_roles(value: string[]) {
        this._user_roles = value;
    }

    // This function, when present, is automatically
    // called by the JSON.stringify function.
    public toJSON(stringifyExclude: string[]) {
        return this.flatten(BaseUser.stringifyExclude.concat(stringifyExclude));
    }

    public flatten(exclude: string[]): Object {

        let outObj = Object.create(null);

        for (let key in this) {
            outObj = this.addProperty(this, outObj, key, exclude);
        }

        return outObj;
    }

    protected addProperty(inObj: any, outObj: any, key: string, exclude: string[] | undefined): Object {
        if ((exclude == undefined)
            || (!exclude.includes(key))) {
            let k: string = key;

            if (k.charAt(0) == "_") {
                k = key.substring(1);
            }

            const value = inObj[k];
            outObj[k] = value ? value : null;
        };

        return outObj;
    }
}
